
/* Blog Filter */
$(document).ready(() => {
    let mainBlog = false;
    let currentBlog = false;
    let currentTags = false;
    let mainBlogHandle = false;
    let image = document.querySelector('.blog-2 .blog-banner img');

    $(document).on('click', '.blog-pagination .pagination--item', function (e) {
        e.preventDefault();

        const url = $(this).attr('href');

        functionFilterPosts({}, url);
    });

    $(document).on('click', '[data-blog-filter-category-title]', function (e) {
        if (e.target.tagName.toLowerCase() === 'h4') {
            e.preventDefault();

            $(this).parents('.filter-option').toggleClass('open');
            $(this).next().animate({ height: 'toggle' });
        }
    });

    $(document).on('click', '[data-blog-filter-toggle-mobile]', function (e) {
        e.preventDefault();

        $('body').toggleClass('filters-open');
    });

    $(document).on('click', '.blog-filters', function (e) {
        e.preventDefault();
        $('body').toggleClass('filters-open');
    });

    $(document).on('click', '.blog-filters-wrapper', function (e) {
        e.stopPropagation();
    });


    $(document).on('submit', '[data-blog-filter-form]', function (e) {
        e.preventDefault();

        const input = $('[data-blog-filter-form-input]').val();

        if (input) {
            window.location = `/blogs/${mainBlogHandle}?q=${input}`;
        }
    });

    function showLoader() {
        let postsHtml = '<div class="blog-top-filters card-loader"></div>';
        postsHtml += `<div class="blog--inner">
      `
        for (var i = 0; i < 10; i++) {
            postsHtml += `<li class="article--excerpt-wrapper">
          <article class="article-list-item card-loader">
            <div class="article--excerpt-image post-image"></div>
            <div class="article--excerpt-content post-content">
              <div class="article--excerpt-meta"></div>
              <p></p>
              <h3></h3>
              <p></p>
              <p></p>
              <p></p>
              <p></p>
            </div>
          </article> 
        </li>`;
            `
      </div>`

        }

        $('[data-blog-posts]').html(postsHtml);
    }

    function checkUrlParams() {
        const urlParams = new URLSearchParams(window.location.search);
        const qParam = urlParams.get('q');

        if (qParam) {
            const params = {
                type: 'article',
                q: qParam
            };

            functionFilterPosts(params, '/search');

            $('[data-blog-filter-form-input]').val(qParam);
            $('body').removeClass('filters-open');
            $('[data-blog-banner-search-q]').text(qParam);
            $('[data-blog-banner-search]').show();
            $('[data-blog-banner]').hide();
        } else {
            if (mainBlog == currentBlog) {
                let params = {
                    type: 'article',
                    q: '&nbsp;'
                };

                if (currentTags != '') {
                    params.q = `tag:"${currentTags}"`;
                }

                // functionFilterPosts(params, '/search');
            }
        }
    }

    function functionFilterPosts(data, url) {
        console.log('url========>', url);
        showLoader();

        const params = {
            type: 'GET',
            url: url,
            data: data
        };

        $.ajax(params).done(function (response) {
            $('[data-blog-posts]').html($(response).find('.blog-posts').html());
            $('[data-blog-pagination]').html($(response).find('.blog-posts-pagination').html());

            $(`.article--excerpt-image img`).each(function (item) {
                window.loadImage($(this)[0], { "round": 1 })
            })
            $(window).scrollTop(0);
        });
    }

    function init() {
        const dataEl = $('[data-section-type="static-blog-2"]');

        if (dataEl.length > 0) {

            const data = JSON.parse(dataEl.data('section-data') || dataEl.html());

            mainBlog = data.mainBlog;
            currentBlog = data.currentBlog;
            currentTags = data.currentTags;
            mainBlogHandle = data.mainBlogHandle;

            checkUrlParams();
        }
    }

    init();
});